<template>
<div></div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import getWechatCodeHelper from '@/helpers/getWechatCodeHelper';
import localStorageHelper from '@/helpers/localStorageHelper';
import { AUTH_TOKEN_KEY } from '@/helpers/constants';

export default {  
  created() {
    if (getWechatCodeHelper.getUrlCode('code')) {
      const code = getWechatCodeHelper.getUrlCode('code');
      QuestionQuery.wechatAuthorize(code).then(res => {
        localStorageHelper.setItem(AUTH_TOKEN_KEY, res.access_token);
        eventBus.$emit('userLogin');
        if (this.$router.currentRoute.path !== '/') {
          this.$router.push({ path: '/' }, () => {});
        }
      });
    }
  }
};
</script>

